import { Alert, Button, Stack } from '@mantine/core';
import { Component, type ReactNode } from 'react';
import { tr } from '../lib/i18n';

/** Keeps a crash in one page from blanking the whole app. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }
  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <Stack gap="md" p="md" align="flex-start">
        <Alert color="red" variant="light" w="100%">{tr('حدث خطأ غير متوقع في هذه الصفحة:', 'An unexpected error occurred on this page:')} {this.state.error.message}</Alert>
        <Button variant="default" onClick={() => this.setState({ error: null })}>{tr('إعادة المحاولة', 'Try again')}</Button>
      </Stack>
    );
  }
}
